import {API_BASE_URL, PATH_ACTIVE, PATH_CLIENTS, PATH_CONNECTION_ACTIVITY} from '../constants/constants';
import {request, run, getFiltersAsQuery} from "./APIService";

export function getClientById(clientId) {
    return request({
        url: API_BASE_URL + PATH_CLIENTS + "/" + clientId,
        method: 'GET'
    }, []);
}

export function getClients(page, size, filters) {
    return request({
        url: API_BASE_URL + PATH_CLIENTS + '?page=' + page + '&size=' + size + '&q=' + getFiltersAsQuery(filters),
        method: 'GET'
    }, []);
}

export function getAllClients() {
    return getClients(0, 100, undefined)
}

export function getActiveClients() {
    return request({
        url: API_BASE_URL + PATH_CLIENTS + PATH_ACTIVE,
        method: 'GET'
    }, []);
}

export function updateClient(client) {
    return request({
        url: API_BASE_URL + PATH_CLIENTS + "/" + client.id,
        method: 'PUT',
        body: JSON.stringify(client)
    }, []);
}

export function createClient(client) {
    return request({
        url: API_BASE_URL + PATH_CLIENTS,
        method: 'POST',
        body: JSON.stringify(client)
    }, []);
}

export function deleteClient(id) {
    return run({
        url: API_BASE_URL + PATH_CLIENTS + '/' + id,
        method: 'DELETE'
    }, []);
}

export function getConnectionActivity(page, size, filters) {
    let q = getFiltersAsQuery(filters);
    return request({
        url: API_BASE_URL + PATH_CLIENTS + PATH_CONNECTION_ACTIVITY + '?page=' + page + '&size=' + size + '&q=' + q,
        method: 'GET'
    }, []);
}


// WEBPACK FOOTER //
// ./src/app/services/ClientsService.js